import { Component, inject, input } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { CapabilityConfigurationFormControl } from '../../../../core/forms';
import { BookingConfigService } from '../../../../core/services/booking-config.service';
import { CalendarWithMeetingTypes } from '../../../../core/interfaces/config.interface';
import { KeyValuePair } from '@vendasta/ai-assistants';

const MEETING_URL = '../../../../events-and-meetings';

@Component({
  selector: 'ai-book-me-now-capability-form',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    TranslateModule,
    GalaxyFormFieldModule,
    AsyncPipe,
  ],
  templateUrl: './book-me-now-capability-form.component.html',
  styleUrl: './book-me-now-capability-form.component.scss',
})
export class BookMeNowCapabilityFormComponent {
  private readonly bookingConfigService = inject(BookingConfigService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  configurationForm = input.required<CapabilityConfigurationFormControl>();

  protected readonly calendarsWithTypes$ = this.bookingConfigService.getCalendarsWithTypes();

  protected readonly compareBookingOptions = (
    option1: CalendarWithMeetingTypes['meetingTypes'][0] | null,
    option2: CalendarWithMeetingTypes['meetingTypes'][0] | null,
  ): boolean => {
    if (!option1 || !option2) return false;
    return option1.calendarId === option2.calendarId && option1.meetingTypeId === option2.meetingTypeId;
  };

 protected onMeetingTypeSelected(event: { value: CalendarWithMeetingTypes['meetingTypes'][0] | null }) {
    if (event.value) {
      this.configurationForm().setValue([
        new KeyValuePair({ key: 'calendarId', value: event.value.calendarId }),
        new KeyValuePair({ key: 'meetingTypeId', value: event.value.meetingTypeId }),
      ]);
    } else {
      this.configurationForm().setValue(null);
    }
  }

 protected goToMeetings() {
    this.router.navigate([MEETING_URL], { relativeTo: this.route });
  }
}
